import { render, staticRenderFns } from "./customCascaderCategoryBack.vue?vue&type=template&id=79637d0e&scoped=true&"
import script from "./customCascaderCategoryBack.vue?vue&type=script&lang=js&"
export * from "./customCascaderCategoryBack.vue?vue&type=script&lang=js&"
import style0 from "./customCascaderCategoryBack.vue?vue&type=style&index=0&id=79637d0e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79637d0e",
  null
  
)

export default component.exports